document.addEventListener("DOMContentLoaded", function () {
  // var sliderName = document.querySelector(".ctaSliderName");
  // var sliderNameValue = sliderName.getAttribute("data-value");
  // sliderName.classList.add(sliderNameValue);
  // console.log(sliderNameValue);
  // var horizontalSlider = new Swiper(`.${sliderNameValue}`, {
  //   autoplay: true,
  //   slidesPerView: 1,
  //   freeMode: false,
  //   loop: true,
  //   watchSlidesProgress: true,
  //   spaceBetween: 13,
  //   centeredSlides: false,
  //   navigation: {
  //     nextEl: ".cta-slider-next-slide",
  //     prevEl: ".cta-slider-prev-slide",
  //   },
  //   breakpoints: {
  //     0: {
  //       slidesPerView: 1,
  //     },
  //     768: {
  //       slidesPerView: 2,
  //     },
  //     1024: {
  //       slidesPerView: 3,
  //     },
  //     1280: {
  //       slidesPerView: 3,
  //     },
  //     1536: {
  //       slidesPerView: 4,
  //     },
  //     1720: {
  //       slidesPerView: 7,
  //     },
  //   },
  // });

  var horizontalSlider = new Swiper(".cta-slider", {
      autoplay: true,
      slidesPerView: 1,
      freeMode: false,
      loop: true,
      watchSlidesProgress: true,
      spaceBetween: 13,
      centeredSlides: false,
      navigation: {
        nextEl: ".cta-slider-next-slide",
        prevEl: ".cta-slider-prev-slide",
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
        },
        430: {
          slidesPerView: 2,
        },
        768: {
          slidesPerView: 3,
        },
        1024: {
          slidesPerView: 4,
        },
        1280: {
          slidesPerView: 5,
        },
        1536: {
          slidesPerView: 6,
        },
        1720: {
          slidesPerView: 7,
        },
      },
    });

  var verticalSwiper = new Swiper(".product-vertical-slider", {
    // direction: "vertical",
    autoplay: true,
    slidesPerView: 3,
    freeMode: true,
    loopedSlides: 3,
    loop: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    spaceBetween: 13,
    breakpoints: {
      0: {
        direction: "horizontal",
      },
      639: {
        direction: "vertical",
      }
    },
  });

  var productSwiper = new Swiper(".single-product-slider", {
    loop: true,
    slidesPerView: 1,
    autoplay: true,
    navigation: false,
    // reverseDirection: true,
    thumbs: {
      swiper: verticalSwiper,
    },
  });
});
